import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 12a2 2 0 1 1 -4 0q 0 -.053 .005 -.102a1.996 1.996 0 0 1 1.995 -1.898a2 2 0 0 1 2 2","key":"svg-0"}],["path",{"d":"M14 19a2 2 0 1 1 -4 0q 0 -.052 .005 -.102a1.996 1.996 0 0 1 1.995 -1.898a2 2 0 0 1 2 2","key":"svg-1"}],["path",{"d":"M14 5a2 2 0 1 1 -4 0q 0 -.053 .005 -.102a1.996 1.996 0 0 1 1.995 -1.898a2 2 0 0 1 2 2","key":"svg-2"}]]

const IconDotsVerticalFilled = createReactComponent('filled', 'dots-vertical-filled', 'DotsVerticalFilled', __iconNode);

export default IconDotsVerticalFilled;